<div class="d-grid p-0">
    <button type="submit" class="btn btn-block btn-light-primary mb-0 signin-border" (click)="logOut()" >
      <span class="me-2" *ngIf="isLoading">
        <img src="assets/images/svg/spinner-loader.svg">
      </span>
      <div class="p-0" *ngIf="!isLoading" > 
        <img width="30" src="assets/images/menuicon/logout.png" class="me-2"> <span>Logout</span>
      </div>
    </button>
  </div>